import { render, staticRenderFns } from "./dialog-3.vue?vue&type=template&id=46943727&scoped=true&"
import script from "./dialog-3.vue?vue&type=script&lang=ts&"
export * from "./dialog-3.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-3.vue?vue&type=style&index=0&id=46943727&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46943727",
  null
  
)

export default component.exports